import { Injectable, inject } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../services/profile.service';
import { IProfileData } from '../interfaces/profile.interface';

@Injectable({
  providedIn: 'root',
})
export class UserProfileResolver implements Resolve<IProfileData> {
  private readonly profileService: ProfileService = inject(ProfileService);

  resolve(): Observable<IProfileData> {
    return this.profileService.getProfile();
  }
}
